var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoLeave({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.45 73.3101C84.45 72.3436 83.6665 71.5601 82.7 71.5601C81.7335 71.5601 80.95 72.3436 80.95 73.3101C80.95 74.2766 81.7335 75.0601 82.7 75.0601C83.6665 75.0601 84.45 74.2766 84.45 73.3101Z",
    fill: "#CBD5E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.73 45C80.73 25.2669 64.7331 9.27002 45 9.27002C25.2669 9.27002 9.26999 25.2669 9.26999 45C9.26999 64.7332 25.2669 80.73 45 80.73C64.7331 80.73 80.73 64.7332 80.73 45Z",
    fill: "#F7F9FB",
    stroke: "#E2E6EE",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 75.24V81.38",
    stroke: "#CDD4DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.83 78.3101H16.97",
    stroke: "#CDD4DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.93 13.02C82.9628 13.02 83.8 12.1828 83.8 11.15C83.8 10.1173 82.9628 9.28003 81.93 9.28003C80.8972 9.28003 80.06 10.1173 80.06 11.15C80.06 12.1828 80.8972 13.02 81.93 13.02Z",
    fill: "#E2E6EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 13.02C15.3801 13.02 16.58 11.8202 16.58 10.34C16.58 8.85991 15.3801 7.66003 13.9 7.66003C12.4199 7.66003 11.22 8.85991 11.22 10.34C11.22 11.8202 12.4199 13.02 13.9 13.02Z",
    fill: "#E2E6EE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.89 39.61H16.09V17.97H27.2L31.89 22.51H58.89V39.61Z",
    fill: "white",
    stroke: "#98A2B5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.62 29.38H19.37V38.34H55.62V29.38Z",
    fill: "white",
    stroke: "#98A2B5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.25 62.88H15.72L12.54 35.34H62.43L59.25 62.88Z",
    fill: "white",
    stroke: "#98A2B5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M66.21 64.9L79.54 78.46L74.52 83.4L61.19 69.84",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M66.21 64.9L79.54 78.46L74.52 83.4L61.19 69.84",
    stroke: "#98A2B5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.04 70.65C62.9767 70.65 68.6 65.0267 68.6 58.09C68.6 51.1533 62.9767 45.53 56.04 45.53C49.1033 45.53 43.48 51.1533 43.48 58.09C43.48 65.0267 49.1033 70.65 56.04 70.65Z",
    fill: "#F1F5F9",
    stroke: "#98A2B5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3 45.97L35.71 46.16",
    stroke: "#98A2B5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.02 53.25L35.42 53.44",
    stroke: "#98A2B5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.67 54.48L60.14 61.95",
    stroke: "#98A2B5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.67 61.95L60.14 54.48",
    stroke: "#98A2B5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLeave);
export default __webpack_public_path__ + "static/media/NoLeave.af69d4f93ebe8b0311bb0b0a57382055.svg";
export { ForwardRef as ReactComponent };